module.exports = __webpack_public_path__ + "static/media/mountainByWater.16708ce4.jpg";